/**
 * Generated runtime TestId mirror for frontend/src/pages/Systems.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const SystemsTestIds = {
  btnNewSystem: "btn-new-system",
  colEnvironment: "col-environment",
  colName: "col-name",
  colType: "col-type",
  systemsList: "systems-list",
  linkSystemDetail: (system_id: string) => `link-system-detail-${system_id}`,
  linkSystemDetailPrefix: () => "link-system-detail-" as TestIdPrefix
} as const;
